export default __webpack_public_path__ + "static/category-page-card-ae538d391eb9ae745bb7f050b7a2dd7b.png";